module.exports = __webpack_public_path__ + "img/log_light_1.402b9096.png";